import { twMerge } from "tailwind-merge";
import { Spin } from "antd";

const CustomButton = ({
  children,
  onClick,
  width,
  borderColor = "border-[#51F9EF]",
  type = "button",
  className = "",
  textSize = "text-sm",
  font = "font-Public_Sans",
  textColor = "text-[#51F9EF]", // or "gradient"
  hoverBg = "",
  hoverText = "",
  padding = "py-2 px-4",
  rounded = "rounded-lg",
  bgColor = "bg-transparent",
  useGradientBorder = false,
  gradient = "bg-gradient-to-b from-[#52FAF0] to-[#197AD0]",
  loading = false,
  disabled = false,
  ...props
}) => {
  const spinner = <Spin size="small" className="mr-2" />;

  const isGradientText = textColor === "gradient";
  const textGradientClasses = `bg-gradient-to-b from-[#51F8EF] to-[#1A7DD1] bg-clip-text text-transparent ${gradient}`;
  const resolvedTextColor = isGradientText ? "" : textColor;

  const content = (
    <span
      className={twMerge(
        "flex items-center justify-center whitespace-nowrap gap-2",
        isGradientText && textGradientClasses
      )}
    >
      {loading && spinner}
      {children}
    </span>
  );

  if (useGradientBorder) {
    return (
      <div className={`p-[2px] inline-block ${rounded} ${gradient}`}>
        <button
          type={type}
          onClick={onClick}
          className={twMerge(
            `w-full h-full block ${padding} ${textSize} ${font} ${hoverBg} ${hoverText} ${width} ${bgColor} ${rounded} ${resolvedTextColor} bg-[#101018] flex items-center justify-center`,
            disabled || loading ? "cursor-not-allowed" : "cursor-pointer",
            className
          )}
          disabled={disabled || loading}
          {...props}
        >
          {content}
        </button>
      </div>
    );
  }

  return (
    <button
      type={type}
      onClick={onClick}
      className={twMerge(
        `transition ${textSize} ${font} border ${borderColor} ${bgColor} ${hoverBg} ${hoverText} ${padding} ${width} ${rounded} ${resolvedTextColor} flex items-center justify-center`,
        disabled || loading ? "cursor-not-allowed" : "cursor-pointer",
        className
      )}
      disabled={disabled || loading}
      {...props}
    >
      {content}
    </button>
  );
};

export default CustomButton;
